import PropTypes from "prop-types";
import { Input, InputNumber, Radio } from "top-component-library";
import { FormRow, StackedButtonGroup } from "../styles";

const OrderRateLimitTagMinMaxStep = ({
  availableThrottleSettings,
  checkoutBlockingTag,
  minQty,
  maxQty,
  messageIfViolated,
  onChangeTag,
  onChangeMin,
  onChangeMax,
  onChangeMessage,
}) => (
  <div>
    <h4>Tag to Validate On:</h4>
    <Radio.Group value={checkoutBlockingTag} onChange={(event) => onChangeTag(event.target.value)}>
      <StackedButtonGroup>
        {availableThrottleSettings.map((tag) => (
          <Radio key={tag.name} value={tag.name}>
            {tag.display_name}
          </Radio>
        ))}
      </StackedButtonGroup>
    </Radio.Group>
    <h4>Allowed Range:</h4>
    <FormRow>
      <label htmlFor="minimum-order-size">Minimum</label>
      <InputNumber id="minimum-order-size" min={0} value={minQty ?? undefined} onChange={onChangeMin} />
    </FormRow>
    <FormRow>
      <label htmlFor="maximum-order-size">Maximum</label>
      <InputNumber id="maximum-order-size" min={0} value={maxQty ?? undefined} onChange={onChangeMax} />
    </FormRow>
    <h4>Error Message:</h4>
    <FormRow>
      <label htmlFor="message-if-violated-minmax">Message shown to patrons when their order is blocked</label>
      <Input
        id="message-if-violated-minmax"
        maxLength={250}
        value={messageIfViolated}
        onChange={(event) => onChangeMessage(event.target.value)}
      />
    </FormRow>
  </div>
);

OrderRateLimitTagMinMaxStep.propTypes = {
  availableThrottleSettings: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string.isRequired, display_name: PropTypes.string.isRequired })
  ).isRequired,
  checkoutBlockingTag: PropTypes.string.isRequired,
  minQty: PropTypes.number,
  maxQty: PropTypes.number,
  messageIfViolated: PropTypes.string.isRequired,
  onChangeTag: PropTypes.func.isRequired,
  onChangeMin: PropTypes.func.isRequired,
  onChangeMax: PropTypes.func.isRequired,
  onChangeMessage: PropTypes.func.isRequired,
};

OrderRateLimitTagMinMaxStep.defaultProps = {
  minQty: null,
  maxQty: null,
};

export default OrderRateLimitTagMinMaxStep;
